import React, { useState, useEffect } from "react";
import { useGetAppointmentsQuery } from "../../../services/orderService";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

export const showAppointmentsForPaths = [
  "",
  "condition",
  "age",
  "personal-details",
  "eligibility-success",
];

const AppointmentDateTime = ({ currentPath, className }) => {
  const [date, setDate] = useState();
  const [time, setTime] = useState();
  const [searchParams] = useSearchParams();
  const slotId = searchParams.get("slot-id") === null ? localStorage.getItem("appointment_id") : searchParams.get("slot-id");
  const location = useLocation();
  const preventUpdateStorage = (
    location.pathname === "/onboarding/eligibility-flow/order-success" ||
    location.pathname === "/onboarding/eligibility-flow/order-confirm"
  );

  const { data: appointmentList, isFetching } = useGetAppointmentsQuery({
    page: 0,
    pageSize: 320,
    type: "full",
  });


  const formatWithSuffix = (dateString) => {
    const date = dayjs(dateString);
    const day = date.format("D");
    const month = date.format("MMMM");

    const daySuffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${daySuffix(day)} ${month}`;
  };

  useEffect(() => {
    if (!preventUpdateStorage) {
      const appointment = appointmentList?.content?.find(item => item.id === Number(slotId)) || {};
      localStorage.setItem(
        "appointment_date",
        appointment.datetime ? formatWithSuffix(appointment.datetime) : "-"
      )
      localStorage.setItem(
        "appointment_time",
        appointment.datetime ? dayjs(appointment.datetime).format("hh:mm A").toUpperCase() : "-"
      )
      localStorage.setItem(
        "appointment_full_date",
        appointment.datetime ? dayjs(appointment?.datetime).format('DD/MM/YYYY hh:mm A') : "-"
      )
      localStorage.setItem("appointment_id", slotId)
      setDate(appointment.datetime ? formatWithSuffix(appointment.datetime) : "-")
      setTime(appointment.datetime ? dayjs(appointment.datetime).format("hh:mm A").toUpperCase() : "-")
    }
  }, [appointmentList])

  return (
    <div className="w-100">
      {showAppointmentsForPaths.includes(currentPath) && (
        <p
          className={`d-flex flex-row flex-md-column flex-lg-row gap-md-2 align-items-center px-5 px-md-3 py-1 appointment-bg text-primary-600 mb-0 text-nowrap ${className}`}
        >
          <div className="d-none d-md-flex flex-row gap-2">
            <img
              src="/images/eligibility/note.svg"
              alt="appointment date and time"
              className="google-icon"
            />
            Selected appointment date & time :{" "}
          </div>
          <p className="d-block d-md-none mb-0">
            Selected date and time
          </p>
          <span className="text-black fw-bold d-flex align-items-center">
            {date}
            <hr className="vertical-line mx-2" />
            {time}
          </span>
        </p>
      )}
    </div>
  );
};

export default AppointmentDateTime;
